import type { SalesCommission } from "../../types/commissions";
export function reviewedSelection(
  rows: SalesCommission[],
  ids: number[],
  savedScope: string,
  currentScope: string,
) {
  return savedScope === currentScope
    ? rows.filter((row) => ids.includes(row.id) && row.status === "accrued")
    : [];
}
export function groupCommissions(rows: SalesCommission[]) {
  const groups = new Map<
    number,
    { rep: string; rows: SalesCommission[]; total: number }
  >();
  rows.forEach((row) => {
    const group = groups.get(row.sales_rep) || {
      rep: row.sales_rep_name,
      rows: [],
      total: 0,
    };
    group.rows.push(row);
    group.total += Number(row.final_amount);
    groups.set(row.sales_rep, group);
  });
  return [...groups.values()];
}
export function csvCell(value: unknown) {
  let text = String(value ?? "");
  if (/^[\s]*[=+@-]/.test(text)) text = "'" + text;
  return `"${text.replaceAll('"', '""')}"`;
}
